export const styles = {
  wrapper: { padding: '0 3rem' },
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/TagsManagementCreate/styles.js